import { useEffect, VFC } from "react";

import { FormControlLabel, Switch } from "@portex-pro/ui-components";
import useLDFlag from "hooks/useLDFlag";
import { useTranslation } from "react-i18next";

import { useLtlRequestQuoteSelector } from "../store/ltlState";
import { useSetState } from "../store/ltlStepSlice";

const LtlApiAutoPricingToggleContainer: VFC = () => {
  const { t } = useTranslation(["shipper"]);
  const enableApiAutoPricing = useLtlRequestQuoteSelector((state) => state.ltlStepSlice.enableApiAutoPricing);
  const setState = useSetState();
  const enableLtlAutoPricing = useLDFlag("enableLtlAutoPricing");
  const configureApiAutoPricingToggleDefault = useLDFlag("configureApiAutoPricingToggleDefault");

  useEffect(() => {
    if (enableApiAutoPricing === undefined) {
      setState({ enableApiAutoPricing: !!configureApiAutoPricingToggleDefault });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!enableLtlAutoPricing) {
    return null;
  }

  return (
    <div className="flex items-center justify-center">
      <FormControlLabel
        control={
          <Switch
            checked={enableApiAutoPricing}
            color="primary"
            onChange={(_e, checked) => setState({ enableApiAutoPricing: checked })}
          />
        }
        label={t("shipper:enableApiAutoPricing")}
        labelPlacement="start"
      />
    </div>
  );
};

export default LtlApiAutoPricingToggleContainer;
